import { NomiDescrittoriSezione } from "src/app/common/configuration/nomi-descrittori-sezione";
import { UrlSettingsCore } from "../../configuration/url-settings-core";
import { ConfigurationFeature } from "src/app/common/configuration/models/configuration";

export enum CtxMenuLabelEnum {
    "DASHBOARD" = "Dashboard",
    "AGENDA_LEGALE" = "Agenda legale",
    "RICERCA" = "Ricerca",
    "GESTIONE_SOCIETA" = "Gestione Società",
    "RUBRICA_LEM" = "Rubrica",  // TODO [TSR-197] Da valutare nome
    "ORGANI_LEM" = " Organi",
    "DIPARTIMENTI_LEM" = " Dipartimenti",
    "REPORT" = "Report",
    "ADD_PRATICA" = "Aggiungi nuova pratica",
    /* "CDA_MANAGEMENT"= "Gestione CdA", */
    "UTILITY" = "Utility",
    "ADMIN" = "Amministrazione",
    "DOCUMENT_MANAGEMENT" = "Gestione Documenti",
    "CANCELLERIA_TELEMATICA" = "Cancelleria telematica"
}

export const ctxMenuConfig: CtxMenuConfig[] = [
    {
        label: CtxMenuLabelEnum.DASHBOARD,
        url: UrlSettingsCore.URL_VISUALIZZA_DASHBOARD,
        // descriptor: NomiDescrittoriSezione.DESCRITTORE_DASHBOARD,
        class: ["dashboard"],
        feature: ConfigurationFeature.DASHBOARD
    },
    {
        label: CtxMenuLabelEnum.AGENDA_LEGALE,
        url: UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD,
        class: ["agenda"]
    },
    {
        label: CtxMenuLabelEnum.GESTIONE_SOCIETA,
        url: UrlSettingsCore.URL_GESTIONE_SOCIETA,
        class: ["gestioneSocieta"],
        descriptor: NomiDescrittoriSezione.DESCRITTORE_GESTIONE_SOCIETA,
        feature: ConfigurationFeature.LEM
    },
    {
        label: CtxMenuLabelEnum.ORGANI_LEM,
        url: UrlSettingsCore.URL_ORGANI_LEM,
        class: ["organi"],
        descriptor: NomiDescrittoriSezione.DESCRITTORE_ORGANI,
        feature: ConfigurationFeature.LEM
    },
    {
        label: CtxMenuLabelEnum.DIPARTIMENTI_LEM,
        url: UrlSettingsCore.URL_DIPARTIMENTI_LEM,
        class: ["dipartimenti"],
        descriptor: NomiDescrittoriSezione.DESCRITTORE_DIPARTIMENTI,
        feature: ConfigurationFeature.LEM
    },
    {
        label: CtxMenuLabelEnum.RUBRICA_LEM,
        url: UrlSettingsCore.URL_RUBRICA_LEM,
        class: ["rubrica"],
        descriptor: NomiDescrittoriSezione.DESCRITTORE_RUBRICA,
        feature: ConfigurationFeature.LEM
    },
    {
        label: CtxMenuLabelEnum.RICERCA,
        url: UrlSettingsCore.URL_RICERCA,
        class: ["ricerca"]
    },
    {
        label: CtxMenuLabelEnum.REPORT,
        url: UrlSettingsCore.URL_REPORT,
        class: ["report"],
        descriptor: NomiDescrittoriSezione.DESCRITTORE_REPORTISTICA
    },
    {
        label: CtxMenuLabelEnum.ADD_PRATICA,
        url: UrlSettingsCore.URL_MODULO_PRATICA_CREATE,
        class: ["pratica"],
        modal: true,
        target: "#modaladdpratica",
        descriptor: NomiDescrittoriSezione.DESCRITTORE_CREAZIONE_PRATICA
    },
    /* {
        label: CtxMenuLabelEnum.CDA_MANAGEMENT,
        url: UrlSettingsCore.URL_GESTIONE_CDA,
        class: ["gestioneCdA"],
        descriptor: NomiDescrittoriSezione.DESCRITTORE_GESTIONE_CDA
    }, */
    {
        label: CtxMenuLabelEnum.UTILITY,
        url: UrlSettingsCore.URL_UTILITY,
        class: ["utility"],
        descriptor: NomiDescrittoriSezione.DESCRITTORE_AGGIORNAMENTO_MULTI_CLASSIFICAZIONE
    },
    {
        label: CtxMenuLabelEnum.ADMIN,
        url: UrlSettingsCore.URL_AMMINISTRAZIONE,
        class: ["businessintelligence"],
        descriptor: [
            NomiDescrittoriSezione.DESCRITTORE_GESTIONE_TIPOLOGICHE,
            NomiDescrittoriSezione.DESCRITTORE_GESTIONE_UTENTI,
            NomiDescrittoriSezione.DESCRITTORE_GESTIONE_PROFILI,
            NomiDescrittoriSezione.DESCRITTORE_GESTIONE_FORMULARIO,
            NomiDescrittoriSezione.DESCRITTORE_GESTIONE_TABELLE,
            NomiDescrittoriSezione.DESCRITTORE_GESTIONE_ANAGRAFICHE,
            NomiDescrittoriSezione.DESCRITTORE_GESTIONE_METADATI,
            NomiDescrittoriSezione.DESCRITTORE_CRUSCOTTO_CONSERVAZIONE,
            NomiDescrittoriSezione.DESCRITTORE_CRUSCOTTO_NOTIFICHE
        ],
    },
    {
        label: CtxMenuLabelEnum.DOCUMENT_MANAGEMENT,
        url: UrlSettingsCore.URL_GESTIONE_DOCUMENTI,
        class: ["document-management"],
        descriptor: NomiDescrittoriSezione.DESCRITTORE_GESTIONE_DOCUMENTI,
        feature: ConfigurationFeature.DOCUMENT_INGESTION
    }
]


export interface CtxMenuConfig {
    id?: number;
    key?: string;
    label: string;
    target?: string;
    modal?: boolean;
    class?: string | Array<string>;
    url: string;
    iconUrl?: string;
    descriptor?: string | Array<string>;
    disabled?: boolean;
    feature?: string;
}


